module.exports = __webpack_public_path__ + "static/media/Logo.50083110.svg";